

import Component from 'generic.basecomponent';
import $ from 'jquery';
import Parsley from 'parsleyjs';
import app from 'app-instance';
import helpers from 'helpers';
import createEvent from 'create-event';
import constants from 'general/js/constants';

export const ATTRIBUTE_VALIDATE_ALWAYS = 'data-validate-always';
export const ATTRIBUTE_VALIDATE_NEVER = 'data-validate-never';


let scrollFlag = false;

export default class Form extends Component {
    constructor(el, customSubmitHandler) {
        super(el);
        this.customSubmit = customSubmitHandler;
        this.$container = $(this.container);
        this.formControlSelector = '.js-form-control, .editing-form-control-nested-control';
        this.formMessageSelector = '.js-form-message';
        this.validatedFormElementSelector = '.js-validated-form';
        this.validatedFormSubmitSelector = '.js-validated-form-submit';
        this.generalErrorsContainerSelector = '.js-from-general-errors';
        this.submitButton = this.$container.find('[type=\'submit\'], .js-form-submit');
        this.$generalErrorsContainer = this.$container.find(this.generalErrorsContainerSelector);
        this.init();
    }

    static getParsleyFieldvalue(field) {
        const type = field.$element[0].type;
        let value;
        switch (type) {
            case 'radio':
                value = '';
                field.$elements.forEach(($input) => {
                    if ($input[0].checked) {
                        value = $input[0].value;
                    }
                });
                break;

            case 'checkbox': {
                const arr = [];
                field.$elements.forEach(($input) => {
                    if ($input[0].checked) {
                        arr.push($input[0].value);
                    }
                });
                value = JSON.stringify(arr);
                break;
            }


            default:
                value = field.$element.val();
        }

        return value;
    }

    static initParsley() {
        Parsley.addValidator('server', {
            validateString: (value, c, field) => {
                // if field cant store value we show error just once
                if (Form.isReturnsEmpty(field)) {
                    if (field.serverErrorValue !== true) {
                        field.serverErrorValue = true;
                        return false;
                    }
                    return true;
                }
                // otherwise field is valid only if new value do not matches old one
                if ('serverErrorValue' in field) {
                    return field.serverErrorValue !== Form.getParsleyFieldvalue(field);
                }
                Form.onFieldError(field);

                // field.serverErrorValue = field.$element.val();
                field.serverErrorValue = Form.getParsleyFieldvalue(field);
                return false;
            },
            validateMultiple: (values, c, field) => {
                if ('serverErrorValue' in field) {
                    return field.serverErrorValue !== Form.getParsleyFieldvalue(field);
                }
                field.serverErrorValue = Form.getParsleyFieldvalue(field);
                return false;
            },
            priority: 1024
        });

        Parsley.addMessages('en', {
            type: {
                email: 'Please enter a valid email.'
            }
        });

        /* scroll to invalid field in iOS mobile */
        Parsley.on('form:validate', (form) => {
            if (!form.isValid()) {
                for (let n = 0; n < form.fields.length; n++) {
                    if (form.fields[n].validationResult !== true) {
                        if (app.isIOSMobile) {
                            window.setTimeout(() => {
                                const offset = $(form.fields[n].$element[0]).offset().top;
                                const scroll = (offset - 200 >= 0) ? offset - 200 : 0;
                                $('html,body').animate({
                                    scrollTop: scroll
                                });
                            }, 0);
                        }
                        break;
                    }
                }
            }
        });
    }

    static handledUntrackedField(field) {
        if (field.serverErrorValue !== true) {
            field.serverErrorValue = true;
            return false;
        }

        return true;
    }

    init() {
        this.initMultipleGroup();
        if (!Form.isParsleyInited) {
            Form.initParsley();
            Form.isParsleyInited = true;
        }
        this.initFocusStates();
        setTimeout(() => {
            this.checkFormMessage();
        }, 2000);
        this.initValidation();

        this.initSubmit();
    }

    initMultipleGroup() {
        // used for 'Multiple Choice' control in the Kentico form builder (checkbox list with different names)

        const namedGroupNodes = this.container.querySelectorAll('[data-multiple-group]');
        for (let i = 0; i < namedGroupNodes.length; i++) {
            const groupName = namedGroupNodes[i].getAttribute('data-multiple-group');
            const controls = namedGroupNodes[i].querySelectorAll('input');
            for (let j = 0; j < controls.length; j++) {
                controls[j].setAttribute('data-validate-multiple', groupName);
                controls[j].name = groupName;
            }
        }
    }

    initFocusStates() {
        this.$formControl = this.$container.find(this.formControlSelector);
        this.$formControl.each(function () {
            const $control = $(this);
            $control.find('input[type!=checkbox][type!=radio], textarea, select')
                .focusin(() => {
                    $control.addClass('is-focus');
                })
                .focusout(() => {
                    $control.removeClass('is-focus');
                });
        });
    }

    initValidation() {
        this.validatedFormElement = this.container.parentElement.querySelector(this.validatedFormElementSelector);
        if (!this.validatedFormElement) {
            return;
        }

        const namespace = 'data-validate-';
        const config = {
            excluded: (index, element) => {
                const excludedDefault = Parsley.options.excluded;
                const defaultExclude = element.matches(excludedDefault);
                if (defaultExclude) {
                    return true;
                }

                const validateNeverParent = helpers.getParent(element, `[${ATTRIBUTE_VALIDATE_NEVER}]`);
                if (validateNeverParent) {
                    return true;
                }
                const validateAlwaysParent = helpers.getParent(element, `[${ATTRIBUTE_VALIDATE_ALWAYS}]`);
                return validateAlwaysParent ? false : $(element).is(':hidden');
            },
            namespace,
            errorClass: 'has-error',
            successClass: 'is-success',
            classHandler: field => field.$element.parents(this.formControlSelector),
            errorsContainer: field => field.$element.closest(this.formControlSelector),
            errorsWrapper: '<div class="help-block"></div>',
            errorTemplate: '<div></div>'
        };

        // just for parsley recognize this as form
        this.validatedFormElement.setAttribute(`${namespace}validate`, '');

        this.parsleyForm = new Parsley.Factory(this.validatedFormElement, config);
        this.submit = this.validatedFormElement.querySelector(this.validatedFormSubmitSelector);
        if (this.submit) {
            this.submit.addEventListener('click', this.beforeSubmit.bind(this));
        }

        // check for server errors, set validator message and validate
        this.parsleyForm.fields.forEach((field) => {
            const errors = this.getFieldServerErrors(field);
            if (errors.length) {
                const message = errors.join(', ');
                Form.showFieldError(field, message);
            }
        });

        this.parsleyForm.on('field:error', Form.onFieldError);
    }

    static isReturnsEmpty(field) {
        return field.element.tagName === 'INPUT' && (field.element.type === 'file' || field.element.type === 'password');
    }

    static showFieldError(field, errorMessage) {
        field.options.trigger = 'input';
        field.options.serverMessage = errorMessage;
        field.options.validateIfEmpty = true;
        field.$element.attr('data-validate-server', 'true');
        delete field.serverErrorValue;
        // reset ui for apply new trigger rule

        field.reset();
        field.validate();
    }

    showCustomErrors(errorsArray) {
        const unNamedErrors = [];
        errorsArray.forEach((error) => {
            const name = error.Name;

            if (name !== null) {
                this.parsleyForm.fields.forEach((field) => {
                    if (field.$element[0].name === name) {
                        Form.showFieldError(field, error.Error);
                    }
                });
            } else {
                unNamedErrors.push(error.Error);
            }
        });

        if (unNamedErrors.length) {
            this.showGeneralErrors(unNamedErrors);
        }

        this.parsleyForm.validate();
    }

    showGeneralErrors(errors) {
        if (this.$generalErrorsContainer.length && errors.length) {
            const errorsHtml = errors.join('<br>');
            this.$generalErrorsContainer.addClass('is-visible');
            this.$generalErrorsContainer.html(errorsHtml);
        }
    }

    hideGeneralErrors() {
        this.$generalErrorsContainer.removeClass('is-visible');
    }

    getFieldServerErrors(field) {
        const element = field.$element[0];
        const serverErrorsString = element.getAttribute('data-errors');
        if (serverErrorsString) {
            try {
                return JSON.parse(serverErrorsString);
            } catch (error) {
                console.log(error);
            }
        }

        return [];
    }

    beforeSubmit(e) {
        app.emitEvent('form:beforeSubmit', [this.container]);
        if (this.parsleyForm.validate()) {
            this.doSubmit(e);
        }
    }

    doSubmit(e) {
        this.hideGeneralErrors();

        if (typeof this.customSubmit === 'function') {
            this.customSubmit(e);
        } else {
            this.defaultSubmit();
        }
    }

    defaultSubmit() {
        window.__doPostBack(this.submit.getAttribute('data-clientid'), '');
    }

    static onFieldError(field) {
        const errorEvent = createEvent(constants.EVENT_FIELD_VALIDATION_FAILED);
        errorEvent.field = field;
        field.element.dispatchEvent(errorEvent);
    }

    checkFormMessage() {
        if (!scrollFlag) {
            const messageElement = this.container.querySelector(this.formMessageSelector);
            if (messageElement) {
                const messageTop = messageElement.offsetTop;
                const messageBottom = messageTop + messageElement.offsetHeight;

                const windowTop = document.documentElement.scrollTop || document.body.scrollTop;
                const windowBottom = windowTop + window.innerHeight;

                if ((windowTop > messageTop || windowBottom < messageBottom) && scrollFlag === false) {
                    scrollFlag = true;
                    window.scrollTo(0, messageTop);
                }
            }
        }
    }

    setButtonLoadingStyle() {
        this.submitButton.addClass('is-loading');
    }

    removeButtonLoadingStyle() {
        this.submitButton.removeClass('is-loading');
    }

    initSubmit() {
        const $submitBtn = this.submitButton;

        this.$container.each(function () {
            const $form = $(this);

            $form.find('input[type!=checkbox][type!=radio], textarea, select')
                .on('keyup', (e) => {
                    const key = e.which;
                    if (key == 13) // the enter key code
                    {
                        if (e.target.tagName.toUpperCase() == 'TEXTAREA') return;
                        if ($submitBtn.length) {
                            e.preventDefault();
                            $submitBtn.click();
                            return false;
                        }
                    }
                })
                .on('keydown keypress', (e) => {
                    const key = e.which;
                    if (key == 13) // the enter key code
                    {
                        if (e.target.tagName.toUpperCase() == 'TEXTAREA') return;
                        if ($submitBtn.length) {
                            e.preventDefault();
                            return false;
                        }
                    }
                });

                if($('#CheckboxDropdown').length >0 ){

                    var form = document.getElementById('CheckboxDropdown');
                    var checkBoxes = $(form).find('input');
                    var count = 0;
                
                    var divBoxesChecked = document.getElementById('selectedNumber');
                    divBoxesChecked.innerHTML = 0;
                
                    $(checkBoxes).on('click', function () {
                        $.each(checkBoxes, function (i) {
                            if (checkBoxes[i].checked) {
                                count++;
                            }
                        });
                        if(count > 0) {
                            $(divBoxesChecked).css("display", "inline");
                        }

                        else {
                            $(divBoxesChecked).css("display", "none");
                        }
                        divBoxesChecked.innerHTML = "(" + count + ")";
                        count = 0;

                    });
                 }
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/form/js/generic.form.js